export default {
    storeName: 'Hyper Wash',
    description: 'Hyper Wash subscription service'
}